export function formatContentRange(start: number, end: number, size: number): string {
  return `bytes ${start}-${end}/${size}`;
}
